import { render } from "./Tune.vue?vue&type=template&id=18d04e6a"
import script from "./Tune.vue?vue&type=script&lang=js"
export * from "./Tune.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__